import { AccordionItem, Heading } from '@mm/components';
import { InfoIcon } from '@mm/icons';
import { useChatbotCRUDActions } from '@mm/state/actions/ChatbotCRUDActions';
import ChatbotModel from '@mm/state/model/ChatbotModel';
import { activeChatbotSelector } from '@mm/state/selectors/viewSelectors';
import React from 'react';
import { useSelector } from 'react-redux';
import SubscribeButtonText from './BotSubscriptionSettings/SubscribeButtonText';
import UnsubscribeButtonText from './BotSubscriptionSettings/UnsubscribeButtonText';
import UnsubscribeProcessedMessage from './BotSubscriptionSettings/UnsubscribeProcessedMessage';
import UnsubscribeText from './BotSubscriptionSettings/UnsubscribeText';
import { InvalidEmail } from './QuickQuestionValidation/InvalidEmail';
import { InvalidPhoneNumber } from './QuickQuestionValidation/InvalidPhoneNumber';
import { ResponseNotChosen } from './QuickQuestionValidation/ResponseNotChosen';
import SkipMessage from './QuickQuestionValidation/SkipMessage';
import './SystemMessages.pcss';

export const SystemMessages = () => {
  const chatbot = useSelector(activeChatbotSelector);
  const { update: updateBot } = useChatbotCRUDActions();
  const onBotChange = (nextBot: ChatbotModel) => updateBot(nextBot);

  return chatbot ? (
    <>
      <div className="system-messages">
        <Heading size={3} text="System Messages" />
        <div className="system-messages__info-message">
          <InfoIcon className="system-messages__info-icon" />
          <span>Quick Question Validation & Subscription Settings</span>
        </div>
        <AccordionItem
          openOnMount
          className="system-messages-item"
          arrowClassName="system-messages-item__arrow"
          title="Quick Question Validation"
          description="Customize the messages sent when validation is failed below.
           If you uncheck a message, validation for that type will be skipped."
          descriptionClassName="system-messages-item__description"
          arrowPosition="left"
          closeOnOutsideClick={false}
        >
          <ResponseNotChosen bot={chatbot} onBotChange={onBotChange} />
          <InvalidEmail bot={chatbot} onBotChange={onBotChange} />
          <InvalidPhoneNumber bot={chatbot} onBotChange={onBotChange} />
          <SkipMessage entity={chatbot} />
        </AccordionItem>
        <AccordionItem
          className="system-messages-item"
          arrowClassName="system-messages-item__arrow"
          title="Facebook Subscription Settings"
          description="Bot will send these messages to confirm messaging subscription when a user types STOP or UNSUBSCRIBE"
          descriptionClassName="system-messages-item__description"
          arrowPosition="left"
          closeOnOutsideClick={false}
        >
          <UnsubscribeText entity={chatbot} />
          <SubscribeButtonText entity={chatbot} />
          <UnsubscribeButtonText entity={chatbot} />
          <UnsubscribeProcessedMessage entity={chatbot} />
        </AccordionItem>
      </div>
    </>
  ) : null;
};
